/* The right rail — three Ads slots.
 *
 * These are in the client's layout and part of the revenue model (proposal
 * s.23, AdMob banners), so the space is real rather than decoration.
 *
 * NO AD CODE HERE, DELIBERATELY. The slots are reserved at the right size so
 * the layout is correct and the demo shows true proportions, but nothing loads
 * a third-party script. Wiring AdMob needs the client's publisher account —
 * one of the pending long-leads — and putting a tracking script into the app
 * before that account exists would mean shipping something we cannot configure
 * or turn off.
 *
 * Reserving the height also avoids the layout shift that arrives with real
 * ads: the space is already the right size when they start filling it.
 */
export function AdsRail() {
  return (
    <aside className="sticky top-[72px] space-y-s3 max-h-[calc(100vh-88px)] overflow-y-auto" aria-label="Sponsored">
      <h2 className="pb-s1 text-md font-bold text-ink-2">Sponsored</h2>

      {[0, 1, 2].map((i) => (
        <div
          key={i}
          className="grid h-[220px] place-items-center rounded-md bg-surface shadow-1"
          // Not announced: an empty placeholder is nothing a screen reader
          // needs to hear three times.
          aria-hidden
        >
          <span className="text-sm font-semibold text-ink-3">Ads</span>
        </div>
      ))}
    </aside>
  )
}
